export default "__VITE_ASSET__DAEM3Fsp__"